import Cookie from 'js-cookie'

export const setSelectedСoursesCurriculumToStorage = (coursesId: number, CurriculumId: number) => {
  localStorage.setItem(`courses_${coursesId}_curriculum_select`, CurriculumId.toString())
}

export const getSelectedСoursesCurriculumFromStorage = (coursesId: number) => {
  const key = `courses_${coursesId}_curriculum_select`
  const cookieValue = Cookie.get(key)

  if (cookieValue) {
    Cookie.remove(key)
    localStorage.setItem(key, cookieValue)
  }

  return localStorage.getItem(key)
}
